export enum Type {
  SENTRY = 'sentry/SENTRY',
}
